import { useQuery } from '@tanstack/react-query';
import { getPrijsfavorietenReport, type PrijsfavorietenPayload } from './report';
import { PF_EMPTY, PF_PREVIEW_DEEL2 } from './fixture';

/*
 * Fetches the Prijsfavorieten report. Until the pipeline exists (step 2) every
 * call 404s, so we fall back:
 *   - dev  → the Deel 2 design's numbers (with its Deel 1), so the UI can be
 *            reviewed as the real thing
 *   - prod → zeros, so a deployed build never shows a client invented figures
 * Either way `isPreview` is true and the header shows a "Geen live data" pill.
 */
export function usePrijsfavorietenReport(
  reportId: string,
  baseUrl: string,
): { data: PrijsfavorietenPayload; isPreview: boolean; lastRefreshedAt: string | null } {
  const query = useQuery({
    queryKey: ['prijsfavorieten-report', baseUrl, reportId],
    queryFn: () => getPrijsfavorietenReport(reportId, baseUrl),
    retry: false,
  });

  if (query.data) {
    return { data: query.data.data, isPreview: false, lastRefreshedAt: query.data.meta?.last_refreshed_at ?? null };
  }
  return { data: import.meta.env.DEV ? PF_PREVIEW_DEEL2 : PF_EMPTY, isPreview: true, lastRefreshedAt: null };
}
